import { useEffect, useRef, useState } from "react";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import {
  axiosGet,
  axiosPutWithJson,
  axiosDeleteWithJson,
} from "../../util/axios";
import { generateInspectionDocx } from "../../util/docxGenerator";
import {
  OpenSnackBarWithResultFail,
  OpenSnackBarWithResultSuccess,
} from "../../redux/common/snackBar/thunk";
import {
  DataGrid,
  GridColDef,
  GridRowModel,
  getGridStringOperators,

} from "@mui/x-data-grid";
import moment from "moment";
import { EditNote } from "@mui/icons-material";
import {
  clearSelectedInspectionThunk,
  initInspectionListThunk,
  initSelectedInspectionThunk,
  ChangeExcelEndDateThunk,
  ChangeExcelStartDateThunk,
  ChaneSelectedInspectionThunk,
  InitInspectionSubQuestionThunk,
} from "../../redux/inspection/thunk";
import {
  ESSQuestionList,
  ESSSubQeustionList,
  InspectionList,
} from "../../redux/inspection/state";
import FormDialog from "../../component/common/FormDialog";
import InspectionDetail from "../../component/inspection/InspectionDetail";
import { Button, Grid, InputLabel } from "@mui/material";
import styles from "./InspectionForm.module.css";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { isGovernemnt } from "../../util/form/form";
import { infoCatelogType } from "../../interface/form";
import { handleDownLoadExcel } from "../../util/excel";
import PdfDownloadDialog from "../../component/cleaning/PdfDownloadDialog";
import axios from "axios";
import { initInspectionQuestionAction } from "../../redux/inspection/action";
import { ButtonTextGrid } from "../..";
import { createBooleanFilterOperators } from "../../util/UI";
import {RenderBooleanCell} from "../../component/common/RenderBooleanCell"

function Inspection() {
  const dispatch = useDispatch<IRootThunkDispatch>();
  const [excelDateGroupOpen, setExcelDateGroupOpen] = useState<boolean>(false);
  const dataFetchedRef = useRef(false);
  const {
    inspectionList,
    excelDownloadEndDate,
    excelDownloadStartDate,
    selected_inspection,
  } = useSelector((state: IRootState) => state.inspectionState);
  const [openPhtotandQuestionDialog, setOpenPhtotandQuestionDialog] =
    useState<boolean>(false);
  const [openPdfDownloadDialog, setOpenPdfDownloadDialog] =
    useState<boolean>(false);

  const [openDeleteInspectionDialog, setOpenDeleteInspectionDialog] =
    useState<boolean>(false);

  useEffect(() => {
    const controller = new AbortController();
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    getInspectionData();
    return () => {
      controller.abort();
    };
  }, []);

  const { user } = useSelector((state: IRootState) => state.userAuth);
  const isGovernmentRole = isGovernemnt(user?.token?.role_id as number);

  const columns: GridColDef[] = [
    { field: "inspection_id", headerName: "巡查編號", flex: 1 },
    { field: "code", headerName: "桶編號", flex: 1 },
    { field: "contract", headerName: "合約名稱", flex: 2 },
    { field: "location_cn", headerName: "桶全名", flex: 4 },

    {
      field: "attendance_date",
      headerName: "抵達時間",
      flex: 2,
      renderCell: (data) => (
        <div>
          {data.value ? (
            <div>
              {moment(parseInt(data.value))
                .utcOffset(8)
                .format("YYYY-MM-DD HH:mm:ss")}
            </div>
          ) : null}
        </div>
      ),
    },
    {
      field: "create_date",
      headerName: "巡查日期",
      flex: 2,
      renderCell: (data) => (
        <div>
          {data.value ? (
            <div>
              {moment(parseInt(data.value))
                .utcOffset(8)
                .format("YYYY-MM-DD HH:mm:ss")}
            </div>
          ) : null}
        </div>
      ),
    },

    {
      field: "atttendance_place",
      headerName: "打卡地點",
      flex: 3,
    },

    {
      field: "inspector",
      headerName: "巡查員",
      flex: 1,
    },

    { field: "remarks", headerName: "備註", flex: 2 },
    {
      field: "need_further_action",
      headerName: "需處理",
      flex: 1,
      valueGetter: (params) => (params.value === 1 ? "是" : "否"),
      filterOperators: getGridStringOperators().map((operator) => ({
        ...operator,
        getApplyFilterFn: (filterItem, column) => {
          if (!operator.getApplyFilterFn) return null;
          const baseFilterFn = operator.getApplyFilterFn(filterItem, column);
          if (!baseFilterFn) return null;
          return (params) => {
            const rawValue = params.row.need_further_action;
            const displayValue = rawValue === 1 ? "是" : "否";
            const filterValue = filterItem.value;

            if (filterValue === "是" || filterValue === "否") {
              return displayValue === filterValue;
            }
            if (filterValue === "1" || filterValue === "0") {
              return rawValue === parseInt(filterValue);
            }

            return baseFilterFn({ ...params, value: displayValue });
          };
        },
      })),
      renderCell: (data) => {
        const rawValue = data.row.need_further_action;
        return (
          <div
            style={{
              backgroundColor: rawValue === 1 ? "#f44336" : "#4caf50",
              color: "white",
              padding: "4px 12px",
              borderRadius: "4px",
              display: "inline-block",
              fontWeight: "bold",
            }}
          >
            {rawValue === 1 ? "是" : "否"}
          </div>
        );
      },
    },

    {
      field: "is_approved",
      headerName: "已審批",
      flex: 1,
      valueGetter: (params) => (params.value == 1 ? "是" : "否"),
      filterOperators: createBooleanFilterOperators('is_approved'),
      renderCell: RenderBooleanCell('is_approved'),
    },

    {
      field: "action",
      headerName: "詳情",
      flex: 1,
      renderCell: (param) => (
        <Button
          variant="contained"
          onClick={() => handleClickOpenPhotoAndQuestionButton(param.row)}
        >
          <ButtonTextGrid>
            <EditNote />
            <Grid>詳情</Grid>
          </ButtonTextGrid>
        </Button>
      ),
    },

    {
      field: "delete",
      headerName: "刪除",
      flex: 1,
      renderCell: (param) => (
        <Button
          variant="contained"
          onClick={() => handleDeleteInspectionWholeRecord(param.row)}
          style={{ backgroundColor: "red" }}
        >
          <ButtonTextGrid>
            <EditNote />
            <Grid>刪除</Grid>
          </ButtonTextGrid>
        </Button>
      ),
    },
  ];

  async function handleClickOpenPhotoAndQuestionButton(data: InspectionList) {
    const questionList = await axiosGet("/api/question");
    if (questionList.data.success) {
      let originalList = questionList.data.questionList as ESSQuestionList[];
      let subQuesutionList = questionList.data
        .subQuestionList as ESSSubQeustionList[];
      const quesionListByType = originalList.filter(
        (question) => question.bin_type_id === data.bin_type_id,
      );
      dispatch(initInspectionQuestionAction(quesionListByType));
      dispatch(InitInspectionSubQuestionThunk(subQuesutionList));
    }

    const result = await axiosGet(
      `/api/inspection/detail/${data.inspection_id}`,
    );
    if (result.data.success && data.inspection_id) {
      console.log("result", result.data);
      dispatch(initSelectedInspectionThunk(result.data, data));
    }

    setOpenPhtotandQuestionDialog(true);
  }

  function handleCloseDialog() {
    dispatch(clearSelectedInspectionThunk());
    setOpenPhtotandQuestionDialog(false);
    setOpenDeleteInspectionDialog(false);
  }

  function handleClickExcelBtn() {
    setExcelDateGroupOpen(!excelDateGroupOpen);
  }

  function handleDownloadStartDate(date: Date) {
    dispatch(ChangeExcelStartDateThunk(date));
  }

  function handleDownloadEndDate(date: Date) {
    dispatch(ChangeExcelEndDateThunk(date));
  }

  function DownloadExcel(type: infoCatelogType) {
    if (excelDownloadStartDate && excelDownloadEndDate) {
      handleDownLoadExcel(
        dispatch,
        type,
        excelDownloadStartDate as Date,
        excelDownloadEndDate as Date,
      );
    } else {
      dispatch(OpenSnackBarWithResultFail("未有填寫開始及完結日期"));
    }
  }

  function handleConvertToPdf() {
    setOpenPdfDownloadDialog(true);
  }

  function handleClosePdfDownloadDialog() {
    setOpenPdfDownloadDialog(false);
  }

  async function handlePdfDownloadSubmit(
    reportType: string,
    selectedDate?: moment.Moment | null,
    contractId?: number | null,
    zoneIds?: number[] | null,
    isInternalReport?: boolean,
    contractName?: string | null,
    endDate?: moment.Moment | null,
  ) {
    setOpenPdfDownloadDialog(false);
    dispatch(OpenLoadingBarThunk(true));

    try {
      const token = localStorage.getItem("loginToken");

      const isInspectionReport =
        reportType === "PlasticToiletDocx" || reportType === "SolarToiletDocx";

      if (isInspectionReport) {
        if (!contractId || !selectedDate || !endDate) {
          dispatch(OpenLoadingBarThunk(false));
          dispatch(OpenSnackBarWithResultFail("請選擇合約和日期範圍"));
          return;
        }

        if (selectedDate.isAfter(endDate, "day")) {
          dispatch(OpenLoadingBarThunk(false));
          dispatch(OpenSnackBarWithResultFail("開始日期不能遲於結束日期"));
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API}api/download/inspectionDataForDocx`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
            params: {
              contractId: contractId.toString(),
              startDate: selectedDate.format("YYYY-MM-DD"),
              endDate: endDate.format("YYYY-MM-DD"),
              isInternalReport: isInternalReport ? "true" : "false",
              ...(zoneIds && zoneIds.length > 0 ? { zoneIds: zoneIds.join(",") } : {}),
            },
          },
        );

        if (response.data.success) {
          const inspectionData = response.data.data;

          const templateFileName = isInternalReport
            ? reportType === "PlasticToiletDocx"
              ? "New Plastic Toilet - Inspection Report  Convert Template.docx"
              : "New Solar Toilet -  Inspection Report Convert Template.docx"
            : reportType === "PlasticToiletDocx"
              ? "Plastic Toilet - Inspection Report  Convert Template.docx"
              : "Solar Toilet -  Inspection Report Convert Template.docx";

          const templatePath = `/templates/${templateFileName}`;

          const docxBlob = await generateInspectionDocx(
            templatePath,
            inspectionData,
          );

          const docxFileName = `inspection_report_${selectedDate.format(
            "YYYYMMDD",
          )}_${endDate.format("YYYYMMDD")}.docx`;

          const url = URL.createObjectURL(docxBlob);
          const link = document.createElement("a");
          link.href = url;
          link.download = docxFileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);

          dispatch(OpenLoadingBarThunk(false));
          dispatch(OpenSnackBarWithResultSuccess("報告下載成功"));
          setOpenPdfDownloadDialog(false);
        } else {
          dispatch(OpenLoadingBarThunk(false));
          dispatch(
            OpenSnackBarWithResultFail(
              response.data.message || "未能取得檢查數據",
            ),
          );
        }
      } else {
        const params: Record<string, string> = {
          reportType,
        };

        if (selectedDate) {
          params.date = selectedDate.format("YYYY-MM-DD");
        }

        const queryString = new URLSearchParams(params).toString();
        const response = await axios.get(
          `${process.env.REACT_APP_API}api/download/report${queryString ? `?${queryString}` : ""}`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
            responseType: "blob",
          },
        );

        const blob = new Blob([response.data]);
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "report";
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/i);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1];
          }
        }

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        dispatch(OpenLoadingBarThunk(false));
        dispatch(OpenSnackBarWithResultSuccess("文件下載成功"));
        setOpenPdfDownloadDialog(false);
      }
    } catch (error) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(OpenSnackBarWithResultFail("未能下載報告"));
    }
  }

  async function getInspectionData() {
    dispatch(OpenLoadingBarThunk(true));

    const defaultStartDate = moment()
      .subtract(1, "months")
      .format("YYYY-MM-DD");

    const defaultEndDate = moment().format("YYYY-MM-DD");

    const result = await axiosGet(
      `/api/inspection/?defaultStartDate=${defaultStartDate}&defaultEndDate=${defaultEndDate}`,
    );
    dispatch(OpenLoadingBarThunk(false));
    if (result.data.success) {
      dispatch(initInspectionListThunk(result.data.inspectionData));
    } else {
      dispatch(OpenSnackBarWithResultFail("未能取得查詢資料"));
    }
  }
  const [selectStartDate, setSelectStartDate] = useState(
    moment().subtract(1, "months"),
  );
  const [selectEndDate, setSelectEndDate] = useState(moment());
  const handleStartDate = (date: Date) => {
    setSelectStartDate(moment(date));
  };

  const handleEndDate = (date: Date) => {
    setSelectEndDate(moment(date));
  };

  async function handleFilterDate() {
    dispatch(OpenLoadingBarThunk(true));

    const StartDateString = moment(selectStartDate).format("YYYY-MM-DD");
    const EndDateString = moment(selectEndDate).format("YYYY-MM-DD");

    const result = await axiosGet(
      `/api/inspection/?StartDateString=${StartDateString}&EndDateString=${EndDateString}`,
    );

    if (result.data.success) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(initInspectionListThunk(result.data.inspectionData));
    } else {
      dispatch(OpenSnackBarWithResultFail("未能取得資料"));
    }
  }

  const handleEpdCommentUpdate = async (
    newRow: GridRowModel,
    oldRow: GridRowModel,
  ) => {
    if (
      isGovernmentRole &&
      (!newRow.EpdComment || newRow.EpdComment === oldRow.EpdComment)
    ) {
      return newRow;
    }
    const updatedRow = { ...newRow };
    const data = {
      EpdComment: updatedRow.EpdComment,
      attendanceDate: updatedRow.attendance_date,
      inspectionDate: updatedRow.inspection_date,
      remarks: updatedRow.remarks,
    };
    if (
      window.confirm(
        isGovernmentRole ? "你確定修改跟進備註嗎？" : "你確定修改備註嗎？",
      )
    ) {
      const result = await axiosPutWithJson(
        `/api/inspection/remarks/${updatedRow.inspection_id}`,
        data,
      );
      if (result.data.success) {
        if (isGovernmentRole) {
          dispatch(OpenSnackBarWithResultSuccess(result.data.message[1]));
        } else {
          dispatch(OpenSnackBarWithResultSuccess(result.data.message[0]));
        }
      } else {
        dispatch(OpenSnackBarWithResultFail("未能加上EPD 回應"));
      }

      return updatedRow;
    } else {
      return oldRow;
    }
  };

  function handleDeleteInspectionWholeRecord(data: InspectionList) {
    dispatch(ChaneSelectedInspectionThunk(data));
    setOpenDeleteInspectionDialog(true);
  }

  async function handleSubmitDeleteInspection() {
    try {
      dispatch(OpenLoadingBarThunk(true));
      const result = await axiosDeleteWithJson(
        `api/inspection/?inspection_id=${selected_inspection?.inspection_id}`,
      );
      if (result.data.success) {
        dispatch(
          OpenSnackBarWithResultSuccess(
            `你已成功刪去「${selected_inspection?.bin_full_name}〝紀錄`,
          ),
        );
        setOpenDeleteInspectionDialog(false);
        dispatch(OpenLoadingBarThunk(false));
        window.location.reload();
      }
    } catch (error) {
      console.log("error", error);
      dispatch(
        OpenSnackBarWithResultFail(
          `未能刪除「${selected_inspection?.bin_full_name}〝紀錄`,
        ),
      );
      setOpenDeleteInspectionDialog(false);
      dispatch(OpenLoadingBarThunk(false));
    }
  }

  return (
    <>
      {isGovernmentRole ? (
        <></>
      ) : (
        <Grid className={styles.EnquuryButtonGroup}>
          <Grid></Grid>

          <Grid>
          <Button variant="contained" onClick={handleClickExcelBtn}>
            <ButtonTextGrid>
              EXCEL
            </ButtonTextGrid>
          </Button>
          </Grid>

          <Grid>
          <Button variant="contained" onClick={handleConvertToPdf}>
            <ButtonTextGrid>
              下載報告
            </ButtonTextGrid>
          </Button>
          </Grid>
        </Grid>
      )}
      <div>巡查紀錄</div>

      <div style={{ height: "900px", width: "100%" }}>
        <Grid className={styles.selectedTimeOuterContainer}>
          <Grid className={styles.DateSelectBtnGroup}>
            <Grid>
              <InputLabel htmlFor="enquiry-date-picker">搜索時間</InputLabel>
              <DatePicker
                onChange={(data) => handleStartDate(data! as unknown as Date)}
                value={selectStartDate}
                format="YYYY-MM-DD"
              />
            </Grid>
            <Grid>
              <InputLabel htmlFor="enquiry-date-picker">完結時間</InputLabel>
              <DatePicker
                onChange={(data) => handleEndDate(data! as unknown as Date)}
                value={selectEndDate}
                format="YYYY-MM-DD"
              />
            </Grid>

            <Grid className={styles.ProceedBTnContainer}>
              <Button variant="contained" onClick={() => handleFilterDate()}>
                <ButtonTextGrid>
                  搜索
                </ButtonTextGrid>
              </Button>
            </Grid>
          </Grid>

          {excelDateGroupOpen ? (
            <Grid className={styles.DateSelectBtnGroup}>
              <Grid>
                <InputLabel htmlFor="enquiry-date-picker">開始時間</InputLabel>
                <DatePicker
                  onChange={(data) => handleDownloadStartDate(data! as Date)}
                  value={excelDownloadStartDate}
                  format="YYYY-MM-DD"
                />
              </Grid>
              <Grid>
                <InputLabel htmlFor="enquiry-date-picker">完結時間</InputLabel>
                <DatePicker
                  onChange={(data) => handleDownloadEndDate(data! as Date)}
                  value={excelDownloadEndDate}
                  format="YYYY-MM-DD"
                />
              </Grid>

              <Grid className={styles.ProceedBTnContainer}>
                <Button
                  variant="contained"
                  onClick={() => DownloadExcel("Inspection")}
                >
                  <ButtonTextGrid>
                    下載
                  </ButtonTextGrid>
                </Button>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
        <DataGrid
          rows={inspectionList || []}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 30 },
            },
          }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
          getRowId={(row) => row.inspection_id}
          processRowUpdate={handleEpdCommentUpdate}
        />
      </div>

      <FormDialog
        title="詳細情況"
        open={openPhtotandQuestionDialog}
        handleClose={handleCloseDialog}
        size="xl"
      >
        <InspectionDetail handleCloseDialog={handleCloseDialog} />
      </FormDialog>

      <FormDialog
        title="刪除巡查"
        open={openDeleteInspectionDialog}
        handleClose={handleCloseDialog}
        size="lg"
        handleSubmit={handleSubmitDeleteInspection}
      >
        <Grid>你是確定刪除「{selected_inspection?.location_cn}〝的紀錄</Grid>
      </FormDialog>

      <PdfDownloadDialog
        open={openPdfDownloadDialog}
        onClose={handleClosePdfDownloadDialog}
        onSubmit={handlePdfDownloadSubmit}
        //filter="inspection"
      />
    </>
  );
}

export default Inspection;
